import { useCallback } from 'react';
import { useDefinitionResource } from 'src/components/star-grid/hooks/useDefinitionResource';
import { listDatasets } from 'src/components/star-grid/datasets/services/datasetService';
import type { Dataset } from 'src/components/star-grid/datasets/datasetTypes';

/** A dataset a report may be built on. Filtered here too, so a service that ignores `for_reports` still hides drafts. */
export const isReportableDataset = (dataset: Dataset): boolean => dataset.status === 'published' && (dataset.visibility ?? 'global') === 'global';

/** `forReports`: what Create Report may offer; otherwise every dataset the viewer may see (their drafts included). */
export function useDatasets(forReports: boolean) {
  const fetcher = useCallback(
    async (signal: AbortSignal) => {
      const datasets = await listDatasets(signal, forReports);
      return forReports ? datasets.filter(isReportableDataset) : datasets;
    },
    [forReports]
  );
  const resource = useDefinitionResource(fetcher, { keepPrevious: true });
  return { datasets: resource.data ?? [], loading: resource.loading, error: resource.error?.message ?? null, reload: resource.reload };
}
